import React, { Component } from "react";
import { Typography, TextField, Button } from "@material-ui/core";
import MapWrapper from "./MapContainer/MapWrapper";
import ComponentTemplate from "../../Utilities/TemplateWrappers/ComponentTemplate";

import Geocode from "react-geocode";

export default class JobPackAddress extends Component {
    constructor(props) {
        super(props);
        this.state = { profile: props.profile, edit: props.edit };
        Geocode.setApiKey(props.mapKey);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.profile !== this.props.profile) {
            this.setState({ profile: this.props.profile });
        }
    }
    renderAddressSearchBar = () => {
        const { profile } = this.state;
        if (this.state.edit) {
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginTop: "7px",
                        marginBottom: "13px",
                        marginLeft: "12px",
                        marginRight: "12px",
                    }}
                >
                    <TextField
                        style={{ width: "50%", marginRight: 20 }}
                        value={profile.address}
                        label="Search Address"
                        onChange={(event) => {
                            this.props.callback("address", event.target.value);
                        }}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ color: "white", background: "#0188cc" }}
                        onClick={() => {
                            if (profile.address.length > 6)
                                Geocode.fromAddress(profile.address).then(
                                    (response) => {
                                        const {
                                            lat,
                                            lng,
                                        } = response.results[0].geometry.location;
                                        profile.location_lat = lat;
                                        profile.location_long = lng;
                                        this.props.callback(
                                            "location_lat",
                                            lat
                                        );
                                        this.props.callback(
                                            "location_long",
                                            lng
                                        );
                                    },
                                    (error) => {}
                                );
                        }}
                    >
                        <Typography
                            variant="caption"
                            style={{ color: "white" }}
                        >
                            Find Address On Map
                        </Typography>
                    </Button>
                </div>
            );
        } else {
            return (
                <div
                    style={{
                        marginLeft: 50,
                        marginBottom: 10,
                    }}
                >
                    <Typography
                        style={{ color: "#0188cc", fontSize: "15px" }}
                        variant="subtitle2"
                    >
                        {this.state.profile.address}
                    </Typography>
                </div>
            );
        }
    };
    render() {
        const { profile } = this.state;
        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={false}
                label="Jobpack Address"
            >
                <div style={{ padding: 20 }}>
                    <MapWrapper
                        lat={
                            profile.location_lat === ""
                                ? 53.35046029646121
                                : profile.location_lat
                        }
                        long={
                            profile.location_long === ""
                                ? -6.2605484635565745
                                : profile.location_long
                        }
                        action={
                            (this.onMapClick = (e, t, v) => {
                                Geocode.fromLatLng(
                                    v.latLng.lat(),
                                    v.latLng.lng()
                                ).then(
                                    (response) => {
                                        this.props.callback(
                                            "address",
                                            response.results[0]
                                                .formatted_address
                                        );
                                        this.props.callback(
                                            "location_lat",
                                            v.latLng.lat().toString()
                                        );
                                        this.props.callback(
                                            "location_long",
                                            v.latLng.lng().toString()
                                        );
                                    },
                                    (error) => {}
                                );
                            })
                        }
                    />
                </div>
                {this.renderAddressSearchBar()}
            </ComponentTemplate>
        );
    }
}
